// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles-module--inner--1rpBn","fileblock":"styles-module--fileblock--2xw-t"};